import "react-image-lightbox/style.css";
import "./Map.scss";

import * as d3 from "d3";

import { ObjectInterface, objectModification } from "../../helpers/objectInterface";
import React, { useEffect, useRef, useState } from "react";
import { descriptionBoxStyle, handleResize, labelWordCount } from "../../helpers/mixHelpers";
import { getTransformScale, handleMouseOut } from "../../helpers/transformation";

import Lightbox from "react-image-lightbox";
import { Line } from "rc-progress";
import PropTypes from "prop-types";
import { Random } from "random-js";
import Search from "./Search";
import SocialShare from "./SocialShare";
import exoplanet from "../../images/green-planet.svg";
import exoplanetGrey from "../../images/green-planet-grey.svg";
import exotic from "../../images/exotic.svg";
import exoticGrey from "../../images/exotic-grey.svg";
import galaxy from "../../images/galaxy.svg";
import galaxyGrey from "../../images/galaxy-grey.svg";
import { getZoomDirection } from "../../helpers/zoomHelper";
import nebula from "../../images/nebula.svg";
import nebulaGrey from "../../images/nebula-grey.svg";
import searchIcon from "../../images/search.png";
import star from "../../images/star.svg";
import starGrey from "../../images/star-grey.svg";
import toggleIcon from "../../images/copy-icon.png";

// @ts-ignore
// This only needs to be imported once in your app
// @ts-ignore
let svg;
let zoom: any;
let node: any;
let currentSelect = -100;
let highlightIndex = -100;
let fontWeight = 0;
let imageSize = 0;
let imgX = 6;
let imgY = 22;
let labX = 8;
let labY = 5;
let xHolder: any;
let yHolder: any;
let firstZoomed = false;
let lastZoom = 0;
let lastZoomDirection = "in";
let lastUpdatedIndex = -100;
let lastDeltaCoords = 0;
let cordsX: any[] = [];
let cordsY: any[] = [];
//Special objects
let upperObjects = ["E015", "C035", "C038"];
let rightObjects = ["B1109", "B0217", "B0412", "C025", "B0204", "M001", "B1116"];
let upperObjectsIndices: any[] = [];
let rightObjectsIndices: any[] = [];
let allCordIndex: any[] = [];
let sharedObject: any;
let selectedIndex = -100;

//loader function
function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef();
  useEffect(() => {
    // @ts-ignore
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      // @ts-ignore
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

// noinspection JSUnusedLocalSymbols
export function Map(props: any) {

  const [starCategory, setStarCategory] = useState(true);
  const [galaxyCategory, setGalaxyCategory] = useState(true);
  const [nebulaCategory, setNebulaCategory] = useState(true);
  const [exoticCategory, setExoticCategory] = useState(true);
  const [exoplanetCategory, setExoplanetCategory] = useState(true);

  const [sWidth] = useState(window.innerWidth);
  // eslint-disable-next-line
  const [sHeight] = useState(window.innerHeight);
  const x = d3.scaleLinear().range([0, sWidth]).domain([-180, 180]);
  const y = d3.scaleLinear().range([0, sHeight]).domain([-90, 90]);
  // social sharing object START

  let shared_url = window.location.href ? window.location.href : "";
  let cm_object = shared_url.indexOf("#") > -1 ? shared_url.substring(shared_url.indexOf("#") + 1) : null;
  let base_url = (shared_url.indexOf("#") > -1) ? shared_url.slice(0, shared_url.indexOf("#")) : shared_url;


  if (cm_object != null) {
    d3.select("[c_m='" + cm_object + "']").each(function() {
      sharedObject = {
        x: d3.select(this).attr("x"),
        y: d3.select(this).attr("y"),
        c_m: d3.select(this).attr("c_m"),
        index: d3.select(this).attr("index"),
      };
    });
    if (sharedObject !== undefined) {
      cm_object = null;
      window.history.pushState("object or string", "Title", base_url);
      sharedObjectHandleObjectClick(sharedObject);
    }
  }
  //social sharing object END

  /*
    Renders the Map
  */

  //font and image thumbnail
  const [loadPercent, setLoadPercent] = useState(0);
  const [fontSize, setFontSize] = useState(30);
  const [thumbImageSize] = useState(20);


  //image and label positions
  let [sImgX] = useState(6);
  let [sImgY] = useState(22);
  let [slabX] = useState(8);
  let [slabY] = useState(5);


  //light Box and legend bar values
  const [isLightBoxOpen, setLightBox] = useState(false);
  const [isSearchBoxEnable, setSearchBox] = useState(false);
  const [lightBoxImage, setLightBoxImage] = useState("");
  const [lightBoxFullImage, setLightBoxFullImage] = useState("");
  const [lightBoxTitle, setLightBoxTitle] = useState("");
  const [lightBoxDescription, setLightBoxDescription] = useState("");
  const [lightBoxUrl, setLightBoxUrl] = useState("");
  const [shareableId, setShareableId]: any = useState("");
  const [shareMediaUrl, setShareMediaUrl]: any = useState("");


  //zoom on searched object
  const handleSearchResult = (data: any) => {
    if (!data.length) {
      return false;
    }
    setSearchBox(false);
    d3.select("[c_m='" + data[0].Caldwell_Messier + "']").each(function() {
      sharedObject = {
        x: d3.select(this).attr("x"),
        y: d3.select(this).attr("y"),
        c_m: d3.select(this).attr("c_m"),
        index: d3.select(this).attr("index"),
      };
    });
    if (sharedObject !== undefined) {
      sharedObjectHandleObjectClick(sharedObject);
    }
  };

  const boxData = [
    "",
    <span key="1">
      <div className="row accordion">
        <div className="col">
          <div className="tabs">
            <div className="tab">
              <div className="socialIconStyle">
                <SocialShare
                  url={window.location.href + `#${shareableId}`}
                  mediaTitle={lightBoxTitle}
                  mediaQuote={lightBoxDescription}
                  mediaUrl={window.location.href + shareMediaUrl}
                  c_m={shareableId}
                />
              </div>
              <input type="checkbox" id="checkbox_hide_info" />
              <label className="tab-label" htmlFor="checkbox_hide_info">
                <span className={"hide_info_label"}>Hide Info &nbsp;| &nbsp;</span>
                <span className={"show_info_label"}>Show Info &nbsp;| &nbsp;</span>
                <span>
                  <a href={lightBoxFullImage} target="_blank" rel="noopener noreferrer">
                    <span className="hide_info_a">See Full Image &nbsp;| &nbsp;</span>
                  </a>
                </span>
                <span>
                  <a href={lightBoxUrl} target="_blank" rel="noopener noreferrer">
                    <span className="hide_info_a">More Info</span>
                  </a>
                </span>
              </label>
              <div className="tab-content" style={descriptionBoxStyle}>
                <div>
                  <h2>{lightBoxTitle}</h2>
                  <span className="result-description">{lightBoxDescription}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </span>,
  ];
  //assigning state values to local variables
  fontWeight = fontSize;
  imageSize = thumbImageSize;
  imgX = sImgX;
  imgY = sImgY;
  labX = slabX;
  labY = slabY;

  function renderImage() {
    /*Renders background image*/
    [star, galaxy, nebula, exotic].forEach(
      (picture) => {
        const img = new Image();
        img.src = picture;
      },
    );
    // @ts-ignore
    svg = d3.select("#render_map2").append("svg").attr("width", sWidth).attr("height", sHeight);
    node = svg.append("g").attr("class", "scale-holder").attr("transform", "translate(0, 0) scale(1)");
    zoom = d3
      .zoom<any, unknown>()
      .scaleExtent([1, 30])
      .translateExtent([
        [0, 0],
        [sWidth, sHeight],
      ])
      .on("zoom", zoomed);

    svg.call(zoom);
    /*
      Appends the image to node
    */
    let imgG = node.append("g");
    imgG
      .insert("svg:image")
      .attr("preserveAspectRatio", "none")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", sWidth)
      .attr("height", sHeight)
      .attr("xlink:href", process.env.PUBLIC_URL + "/background_image_set/image-1.jpg");
    imgG
      .insert("svg:image")
      .attr("preserveAspectRatio", "none")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", sWidth)
      .attr("height", sHeight)
      .attr("xlink:href", process.env.PUBLIC_URL + "/background_image_set/image.jpg");
    drawObjects(8);
  }


  function drawObjects(size?: number) {
    //append shapes on background image
    for (let index = 0; index < props.ObjectCoordinates().length; index++) {
      let objectInterface: ObjectInterface = props.ObjectCoordinates()[index];
      const item = objectModification(Object.assign({}, objectInterface));
      if (item.Caldwell_Messier.includes("M")) {  // This condition makes this app Messier
        let mY = y(Number(item.Latitude));
        let mX = x(Number(item.Longitude));
        let c_m = item.Caldwell_Messier;
        let category = item.Category;
        if (upperObjects.includes(c_m)) upperObjectsIndices.push(index);
        if (rightObjects.includes(c_m)) rightObjectsIndices.push(index);
        cordsX[index] = mX;
        cordsY[index] = mY;
        allCordIndex.push(c_m);
        if (node.select(".coords[index='" + index + "']").size() === 0) {
          let shape = star;

          switch (item.Category) {
            case "ST":
              shape = star;
              break;
            case "G":
              shape = galaxy;
              break;
            case "N":
              shape = nebula;
              break;
            case "C":
              shape = exotic;
              break;
            case "P":
              shape = exoplanet;
              break;
          }
          /*
           Inserts thumbnails on click
          */

          const rect = node
            .insert("svg:image")
            .attr("class", "coords")
            .attr("preserveAspectRatio", "none")
            .attr("x", mX)
            .attr("y", mY)
            .attr("width", size)
            .attr("height", size)
            .attr("cursor", "pointer")
            .attr("index", index)
            .attr("c_m", c_m)
            .attr("category", category)
            .attr("xlink:href", shape)
            .attr("opacity", "0")
            .on("click", handleObjectClick)
            .on("mouseover", handleHover)
            // eslint-disable-next-line
            .on("mouseout", function() {
              handleMouseOut(index, currentSelect, node);
            });
          rect.transition().duration(new Random().integer(500, 2000)).attr("opacity", "1");

        }
      }
    }
  }

  function reChangeObjects(c_m?: any, hoveredX?: number, hoveredY?: number, labelWordCount?: number, settings?: any, action?: any) {
    /*
      Renders objects / shapes
    */

    // Adjust individual items here

    if (c_m === undefined) {
      //  If c_m is not passed, do not execute the function
      return false;
    }

    let scale = getTransformScale(d3);

    if (upperObjects.includes(c_m)) {
      settings["imgY"] = -10;

      return settings;
    }

    if (rightObjects.includes(c_m)) {
      settings["imgX"] = -25;
      settings["imgY"] = 30;
      settings["labX"] = -30;
      settings["labY"] = -5;

      if (c_m === "B0204") {
        if (scale < 1.5 && action === "hover") {
          settings["labX"] = -80;
        } else {
          settings["labX"] = -55;
        }
      }

      if (c_m === "B1116") settings["labX"] = -38;

      return settings;
    }

    //  Returns settings object unconditionally
    return settings; // Must NOT remove this return
  }

  function changeSize(size: number) {
    /*
      Resizes shapes on zoom
    */
    d3.selectAll(".coords")
      .attr("width", function() {
        return size;
      })
      .attr("height", function() {
        return size;
      });
  }

  function resizeThumbs(size: number) {
    /*
      Resizes thumbnails on zoom
    */

    d3.selectAll(".rect-border, .hover_image")
      .attr("width", function() {
        return size;
      })
      .attr("height", function() {
        return size;
      });
  }

  function resizeText(size: number) {
    /*
      Resizes labels on zoom
    */
    d3.selectAll(".label")
      .attr("font-size", function() {
        return size + "%";
      });
  }

  function adjustThumbs(deltaX: number, deltaY: number, labY: number, labX: number, level: number) {
    /*
      Adjusts thumbnails in the event of resizing to balance the newly created / shrunk gap
    */
    if (selectedIndex === -100 || selectedIndex === undefined || (selectedIndex === lastUpdatedIndex && lastDeltaCoords === deltaY)) {
      return false;
    }

    let imgObj = d3.select(".hover_image[index='" + selectedIndex + "']");
    let rectObj = d3.select(".rect-border[index='" + selectedIndex + "']");
    let labObj = d3.select(".label[index='" + selectedIndex + "']");
    if (!imgObj) {
      setTimeout(function() {
        // wait for it
      }, 100);
    }

    let cordX = cordsX[selectedIndex];
    let cordY = cordsY[selectedIndex];

    let imgDeltaY = cordY + deltaY;
    let imgDeltaX = cordX + deltaX;
    let labDeltaX = cordX + 5;

    // Handle special objects here
    if (upperObjectsIndices.includes(selectedIndex)) {
      if (level === 1) {
        imgDeltaY = cordY - (deltaY + 20);
      } else if (level === 2) {
        imgDeltaY = cordY - (deltaY + 15);
      }

    }
    if (rightObjectsIndices.includes(selectedIndex)) {
      imgDeltaX = cordX - (deltaX + 10);
      labDeltaX = cordX - 20;
    }

    if (allCordIndex[selectedIndex] === "B0204") {
      labDeltaX = cordX + labX;
    }

    imgObj
      .attr("y", imgDeltaY)
      .attr("x", imgDeltaX);

    rectObj
      .attr("y", imgDeltaY)
      .attr("x", imgDeltaX);

    labObj
      .attr("x", labDeltaX)
      .attr("y", cordY + labY);

    lastUpdatedIndex = selectedIndex;
    lastDeltaCoords = deltaY;
  }


  function zoomed() {
    /*
      Handles changes needed to be performed on zoom
    */
    let scale = getTransformScale(d3);
    let zoomDirection;
    zoomDirection = getZoomDirection(lastZoom, scale);
    let zoomDirectionChanged = false;
    if (zoomDirection !== lastZoomDirection) {
      zoomDirectionChanged = true;
    }

    if (d3.event.transform !== null) {
      node.attr("transform", d3.event.transform);

      if (zoomDirection === "in") {

        if (zoomDirectionChanged) {
          scale += 0.1;
        }

        if (scale >= 3 && scale < 4) {
          changeSize(3);
        } else if (scale >= 8 && scale < 9) {
          changeSize(2);
          resizeThumbs(14);
          resizeText(16);
          adjustThumbs(5, -20, -1, -40, 1);
        } else if (scale >= 16 && scale < 17) {
          changeSize(1);
          resizeThumbs(10);
          resizeText(10);
          adjustThumbs(5, -15, -1, -25, 2);
        } else if (scale >= 23 && scale < 24) {
          changeSize(0.8);
        }
      } else if (zoomDirection === "out") {

        if (zoomDirectionChanged) {
          scale -= 0.1;
        }

        if (scale < 3 && scale > 2) {
          changeSize(8);
        } else if (scale <= 4 && scale > 3) {
          changeSize(3);
        } else if (scale <= 9 && scale > 8) {
          changeSize(2);
          resizeThumbs(18);
          resizeText(19);
          adjustThumbs(5, -25, -1, -40, 1);
        } else if (scale <= 17 && scale > 16) {
          changeSize(1);
          resizeThumbs(14);
          resizeText(16);
          adjustThumbs(5, -20, -1, -25, 2);
        } else if (scale <= 24 && scale > 23) {
          changeSize(0.8);
        }
      }
      if (scale < 2) {
        setFontSize(28);
      } else if (scale === 6) {
        setFontSize(18);
      } else if (scale > 6) {
        setFontSize(18);
      }
      reChangeObjects();
    }
    if (firstZoomed) {
      lastZoom = scale;
      lastZoomDirection = zoomDirection;
    }
    firstZoomed = true;

  }

  // noinspection DuplicatedCode
  function boxZoom(x: number, y: number, zoomLevel: number) {
    /*
      Zooms in on objects
     */

    if (x * (zoomLevel - 1) > sWidth * (zoomLevel - 1.5)) {
      x = sWidth - sWidth / zoomLevel / 2;
    }
    if (x * (zoomLevel - 1) < sWidth * 0.5) {
      x = sWidth / zoomLevel / 2;
    }
    if (y * (zoomLevel - 1) > sHeight * (zoomLevel - 1.5)) {
      y = sHeight - sHeight / zoomLevel / 2;
    }
    if (y * (zoomLevel - 1) < sHeight * 0.5) {
      y = sHeight / zoomLevel / 2;
    }
    //d3.event.stopPropagation();

    // @ts-ignore
    svg
      .transition()
      .duration(1000)
      .call(
        // @ts-ignore
        zoom.transform,
        d3.zoomIdentity
          .translate(sWidth / 2, sHeight / 2)
          .scale(zoomLevel)
          .translate(-x, -y),
      );
  }

  // noinspection DuplicatedCode
  function sharedObjectHandleObjectClick(object: any) {
    /*
       Handles object clicks
    */
    const obj = object;
    highlightIndex = obj !== undefined ? obj.index : "";
    d3.selectAll(".hover_image").remove();
    d3.selectAll(".label").remove();
    d3.selectAll(".rect-border").remove();
    currentSelect = highlightIndex;
    let item: ObjectInterface = props.ObjectCoordinates()[highlightIndex];
    let url: any = "";
    let full_url: any = "";
    let open_full_url: any = "";
    let share_media_url: any = "";
    if (item.Caldwell_Messier.includes("M") || item.Caldwell_Messier.includes("C") || item.Caldwell_Messier.includes("B") || item.Caldwell_Messier.includes("E")) {
      url = process.env.PUBLIC_URL + "/thumbnail_images/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
      full_url = process.env.PUBLIC_URL + "/lightbox_images/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
      open_full_url = process.env.PUBLIC_URL + "/full_size_image/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
      share_media_url = "lightbox_images/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
    }
    let moreInfoUrl: any = item["url"];
    if (moreInfoUrl === "" || moreInfoUrl === null) {
      moreInfoUrl = "#";
    }
    let description: string = "Description Not Available";
    if (typeof item["text"] === "string") {
      description = item["text"];
    } else {
      description = "Description Not Available";
    }
    selectedIndex = highlightIndex;
    let useX = Number(obj !== undefined ? obj.x : "");
    let useY = Number(obj !== undefined ? obj.y : "");
    let labelX = Number(obj !== undefined ? obj.x : "");
    let labelY = Number(obj !== undefined ? obj.y : "");
    let c_m = obj !== undefined ? obj.c_m : "";
    xHolder = useX;
    yHolder = useY;

    let settings = {
      "useX": useX,
      "useY": useY,
      "labelX": labelX,
      "labelY": labelY,
      "imgX": imgX,
      "imgY": imgY,
      "labX": labX,
      "labY": labY,
    };
    settings = reChangeObjects(c_m, xHolder, yHolder, labelWordCount(item["WISE Objects"]), settings, "click");
    boxZoom((useX + settings.imgX) + 10, (useY - settings.imgY) + 10, 6);
    node
      .insert("svg:image")
      .attr("class", "hover_image")
      .attr("index", highlightIndex)
      .attr("c_m", c_m)
      .attr("x", useX + settings["imgX"])
      .attr("y", useY - settings["imgY"])
      .attr("width", imageSize)
      .attr("height", imageSize)
      .attr("xlink:href", url);

    const text = node
      .append("text")
      .attr("class", "label")
      .attr("fill", "white")
      .attr("x", labelX + settings["labX"])
      .attr("y", labelY + settings["labY"])
      .attr("font-family", "Arial")
      .attr("index", highlightIndex)
      .attr("c_m", c_m)
      .attr("font-size", fontWeight + "%")
      .html(item["WISE Objects"])
      .attr("opacity", "0");

    text.transition().duration(new Random().integer(100, 1000)).attr("opacity", "1");

    node.append("rect")
      .attr("x", useX + settings["imgX"])
      .attr("class", "rect-border")
      .attr("y", useY - settings["imgY"])
      .attr("width", imageSize)
      .attr("height", imageSize)
      .style("fill", "transparent")
      .attr("cursor", "pointer")
      .attr("index", highlightIndex)
      .attr("c_m", c_m)
      .style("stroke", "green")
      .style("stroke-width", "0.5px").on("click", () => {
      setLightBox(true);
      setLightBoxImage(full_url);
      setLightBoxFullImage(open_full_url);

      setLightBoxTitle(item["WISE Objects"]);
      setLightBoxDescription(description);
      setLightBoxUrl(moreInfoUrl);
      setShareableId(c_m);
      setShareMediaUrl(share_media_url);
    });

  }

  // noinspection DuplicatedCode
  function handleObjectClick() {
    /*
       Handles object clicks
    */
    const $this = this as HTMLElement;
    highlightIndex = Number($this.getAttribute("index"));


    d3.selectAll(".hover_image").remove();
    d3.selectAll(".label").remove();
    d3.selectAll(".rect-border").remove();

    currentSelect = highlightIndex;

    let item: ObjectInterface = props.ObjectCoordinates()[highlightIndex];

    let url: any = "";
    let full_url: any = "";
    let open_full_url: any = "";
    let share_media_url: any = "";
    if (item.Caldwell_Messier.includes("M") || item.Caldwell_Messier.includes("C") || item.Caldwell_Messier.includes("B") || item.Caldwell_Messier.includes("E")) {
      url = process.env.PUBLIC_URL + "/thumbnail_images/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
      full_url = process.env.PUBLIC_URL + "/lightbox_images/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
      open_full_url = process.env.PUBLIC_URL + "/full_size_image/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
      share_media_url = "lightbox_images/" + item.Caldwell_Messier.toLowerCase() + ".jpg";

    }
    let moreInfoUrl: any = item["url"];
    if (moreInfoUrl === "" || moreInfoUrl === null) {
      moreInfoUrl = "#";
    }
    let description: string = "Description Not Available";
    if (typeof item["text"] === "string") {
      description = item["text"];
    } else {
      description = "Description Not Available";
    }

    selectedIndex = highlightIndex;

    let useX = Number($this.getAttribute("x"));
    let useY = Number($this.getAttribute("y"));
    let labelX = Number($this.getAttribute("x"));
    let labelY = Number($this.getAttribute("y"));

    let c_m = $this.getAttribute("c_m");
    xHolder = useX;
    yHolder = useY;

    let settings = {
      "useX": useX,
      "useY": useY,
      "labelX": labelX,
      "labelY": labelY,
      "imgX": imgX,
      "imgY": imgY,
      "labX": labX,
      "labY": labY,
    };

    settings = reChangeObjects(c_m, xHolder, yHolder, labelWordCount(item["WISE Objects"]), settings, "click");
    boxZoom((useX + imgX) + 10, (useY - imgY) + 10, 6);
    setFontSize(19);

    node
      .insert("svg:image")
      .attr("class", "hover_image")
      .attr("index", highlightIndex)
      .attr("c_m", c_m)
      .attr("x", useX + settings["imgX"])
      .attr("y", useY - settings["imgY"])
      .attr("width", imageSize)
      .attr("height", imageSize)
      .attr("xlink:href", url);

    const text = node
      .append("text")
      .attr("class", "label")
      .attr("fill", "white")
      .attr("x", labelX + settings["labX"])
      .attr("y", labelY + settings["labY"])
      .attr("font-family", "Arial")
      .attr("index", highlightIndex)
      .attr("c_m", c_m)
      .attr("font-size", fontWeight + "%")
      .html(item["WISE Objects"])
      .attr("opacity", "0");

    text.transition().duration(new Random().integer(100, 1000)).attr("opacity", "1");

    node.append("rect")
      .attr("x", useX + settings["imgX"])
      .attr("class", "rect-border")
      .attr("y", useY - settings["imgY"])
      .attr("width", imageSize)
      .attr("height", imageSize)
      .style("fill", "transparent")
      .attr("cursor", "pointer")
      .attr("index", highlightIndex)
      .attr("c_m", c_m)
      .style("stroke", "green")
      .style("stroke-width", "0.5px").on("click", () => {
      setLightBox(true);
      setLightBoxImage(full_url);
      setLightBoxFullImage(open_full_url);
      setLightBoxTitle(item["WISE Objects"]);
      setLightBoxDescription(description);
      setLightBoxUrl(moreInfoUrl);
      setShareableId(c_m);
      setShareMediaUrl(share_media_url);
    });

  }

  function handleHover() {
    /*
       handle shape hover
    */

    const $this = this as HTMLElement;
    highlightIndex = Number($this.getAttribute("index"));
    if (currentSelect !== highlightIndex) {
      // noinspection DuplicatedCode
      if (node.select(".hover_image[index='" + highlightIndex + "']").size() === 0) {
        let item: ObjectInterface = props.ObjectCoordinates()[highlightIndex];
        let url: any = "";
        if (item.Caldwell_Messier.includes("M") || item.Caldwell_Messier.includes("C") || item.Caldwell_Messier.includes("B") || item.Caldwell_Messier.includes("E")) {
          url = process.env.PUBLIC_URL + "/thumbnail_images/" + item.Caldwell_Messier.toLowerCase() + ".jpg";
        }

        let useX = Number($this.getAttribute("x"));
        let useY = Number($this.getAttribute("y"));
        let labelX = Number($this.getAttribute("x"));
        let labelY = Number($this.getAttribute("y"));
        let c_m = $this.getAttribute("c_m");
        imgY = 22;

        let settings = {
          "useX": useX,
          "useY": useY,
          "labelX": labelX,
          "labelY": labelY,
          "imgX": imgX,
          "imgY": imgY,
          "labX": labX,
          "labY": labY,
        };

        settings = reChangeObjects(c_m, x(Number(item.Longitude)), y(Number(item.Latitude)), labelWordCount(item["WISE Objects"]), settings, "hover");

        node
          .insert("svg:image")
          .attr("class", "hover_image")
          .attr("index", highlightIndex)
          .attr("c_m", c_m)
          .attr("x", useX + settings["imgX"])
          .attr("y", useY - settings["imgY"])
          .attr("width", imageSize)
          .attr("height", imageSize)
          .attr("xlink:href", url);

        const text = node
          .append("text")
          .attr("class", "label")
          .attr("fill", "white")
          .attr("x", labelX + settings["labX"])
          .attr("y", labelY + settings["labY"])
          .attr("font-family", "Arial")
          .attr("index", highlightIndex)
          .attr("c_m", c_m)
          .attr("font-size", fontWeight + "%")
          .html(item["WISE Objects"])
          .attr("opacity", "0");
        text.transition().duration(new Random().integer(100, 1000)).attr("opacity", "1");
      }
    }
  }

  useEffect(() => {
    renderImage();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, [sWidth, sHeight]);


  React.useEffect(() => {

    imageSize = thumbImageSize;
    imgX = sImgX;
    imgY = sImgY;
    labX = slabX;
    labY = slabY;
    // eslint-disable-next-line
  }, [imgX, imgY, labX, labY]);
  React.useEffect(() => {
      //remove all object form canvas
      d3.selectAll(".coords").remove();
      //check if user perform search action activate all disable objects
      if (isSearchBoxEnable) {
        //pass All in catType to bypass all filters
        props.parentFilter("All", true);
        //make all objects state active
        setExoticCategory(true);
        setGalaxyCategory(true);
        setNebulaCategory(true);
        setStarCategory(true);
        setExoplanetCategory(true);
      }
      //re-draw the canvas
      drawObjects(8);
    },
    // eslint-disable-next-line
    [starCategory, galaxyCategory, nebulaCategory, exoticCategory, isSearchBoxEnable, exoplanetCategory]);

  React.useEffect(() => {
    fontWeight = fontSize;
  }, [fontSize]);
  useInterval(() => {
    if (loadPercent < 100) {
      setLoadPercent(loadPercent + 50);
    }
  }, 200);
  return (
    <>
      <div
        id="render_map2"
        style={{
          width: sWidth + "px",
          height: sHeight + "px",
          margin: "0 auto",
          overflow: "hidden",
        }}
        className={loadPercent >= 100 ? "" : "hidden"}
      >
        <div className="tabs" id="first_tabs_sec">
          <div className="tab inner_tab">
            <label className="tab-label inner_label">
              <img
                onClick={() => {
                  setSearchBox(!isSearchBoxEnable);
                }}
                className="search-img"
                src={searchIcon}
                alt={"search-icon"} />
            </label>
            <input type="checkbox" id="check_1" />
            <label className="tab-label inner_label" htmlFor="check_1">
              <img src={toggleIcon} alt={"Copy icon"} />
            </label>
            <div className="tab-content inner_content">
              <input
                type="checkbox"
                id="starSwitch"
                className="categoryInput"
                checked={starCategory}
                onChange={() => {
                  setStarCategory(!starCategory);
                  props.parentFilter("ST", !starCategory);
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="starSwitch">
                <img src={(starCategory) ? star : starGrey} alt="star" />
                Stars
              </label>
              <input
                type="checkbox"
                id="galaxySwitch"
                className="categoryInput"
                checked={galaxyCategory}
                onChange={() => {
                  setGalaxyCategory(!galaxyCategory);
                  props.parentFilter("G", !galaxyCategory);
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="galaxySwitch">
                <img src={(galaxyCategory) ? galaxy : galaxyGrey} alt="galaxy" />
                Galaxies
              </label>
              <input
                type="checkbox"
                id="nebulaSwitch"
                className="categoryInput"
                checked={nebulaCategory}
                onChange={() => {
                  setNebulaCategory(!nebulaCategory);
                  props.parentFilter("N", !nebulaCategory);
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="nebulaSwitch">
                <img src={(nebulaCategory) ? nebula : nebulaGrey} alt="nebula" />
                Nebula
              </label>
              <input
                type="checkbox"
                id="exoticSwitch"
                className="categoryInput"
                checked={exoticCategory}
                onChange={() => {
                  setExoticCategory(!exoticCategory);
                  props.parentFilter("C", !exoticCategory);
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="exoticSwitch">
                <img src={(exoticCategory) ? exotic : exoticGrey} alt="exotic" />
                Exotic
              </label>

              <input
                type="checkbox"
                id="exoplanetSwitch"
                className="categoryInput"
                checked={exoplanetCategory}
                onChange={() => {
                  setExoplanetCategory(!exoplanetCategory);
                  props.parentFilter("P", !exoplanetCategory);
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="exoplanetSwitch">
                <img src={(exoplanetCategory) ? exoplanet : exoplanetGrey} alt="Exoplanet" />
                Exoplanet
              </label>
            </div>
          </div>
        </div>
        {isSearchBoxEnable && (
          <div className="loader-search">
            <div className="search_modal">
              <div className="search_bar">
                <Search options={props.ObjectCoordinates()} handleSearchResult={handleSearchResult} />
              </div>
            </div>
          </div>
        )}
        {isLightBoxOpen && (
          <>
            <Lightbox
              animationDisabled={true}
              enableZoom={false}
              mainSrc={lightBoxImage}
              imageCaption={boxData}
              onCloseRequest={() => {
                setLightBox(!isLightBoxOpen);
                setLightBoxImage("");
              }}
            />
          </>
        )}
      </div>
      <div className={"loader " + (loadPercent >= 100 ? "loaded" : "")}>
        <div className="loader-inner">
          <Line percent={loadPercent} strokeWidth={2} strokeColor="#D3D3D3" />
        </div>
      </div>
    </>
  );
}

Map.prototype = {
  sharedObjectCm: PropTypes.any,
  baseUrl: PropTypes.any,
};
export default Map;
